import { resolveApiBaseUrl, resolveUploadUrl } from './apiBase';

const API_BASE_URL = resolveApiBaseUrl();

export const absoluteHeroImageUrl = (val) => {
  if (!val) return '';
  if (/^https?:\/\//i.test(val)) return val;
  if (!val.startsWith('/')) return val;
  if (val.startsWith('/uploads/')) {
    return resolveUploadUrl(val);
  }
  return `${process.env.PUBLIC_URL || ''}${val}`;
};

export const fetchHeroSlides = async () => {
  try {
    const url = `${API_BASE_URL}/api/hero-slides?t=${Date.now()}`;
    const res = await fetch(url, { cache: 'no-store' });
    if (!res.ok) return [];
    const data = await res.json();
    if (!data.success || !Array.isArray(data.data)) return [];
    return data.data.map((slide) => ({
      id: slide.id,
      collapsedText: slide.collapsedText || '',
      headline: slide.headline || '',
      subText: slide.subText || '',
      contactLink: slide.contactLink || '/contact',
      imageDesktop: absoluteHeroImageUrl(slide.imageDesktop),
      imageMobile: absoluteHeroImageUrl(slide.imageMobile || slide.imageDesktop),
      imageAlt: slide.imageAlt || '',
      imageBlur: slide.imageBlur ?? 2,
    }));
  } catch (error) {
    console.error('Hero slides fetch error:', error);
    return [];
  }
};
